export default {
    LOAD_PRODUCT_BRANDS (state, productbrands) {
        state.items = productbrands
    }
}